import isBoolean from 'lodash/isBoolean';
import isObject from 'lodash/isObject';
import { getConfig as getDataSetConfig } from 'choerodon-ui/dataset';
export function isCustomizable(target) {
    return isObject(target);
}
export function getConfig(key) {
    return getDataSetConfig(key);
}
export function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) {
        return customizePrefixCls;
    }
    return `${getConfig('prefixCls')}-${suffixCls}`;
}
export function getProPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) {
        return customizePrefixCls;
    }
    return `${getConfig('proPrefixCls')}-${suffixCls}`;
}
export function getCustomizable(component) {
    const customizable = getConfig('customizable');
    if (isBoolean(customizable)) {
        return customizable;
    }
    if (isCustomizable(customizable)) {
        return customizable[component];
    }
}
